export const UnknownContainer = {
    id: 'unknown',
    name: 'Unknown',
    accepts: {
        containers: /.*/gi,
        components: /.*/gi,
        default: 'VERTICAL_FLOW'
    },
    axis: 'y'
};

export const Containers = [
    {
        id: 'VERTICAL_FLOW',
        name: 'Rows',
        accepts: {
            containers: /.*/gi,
            components: /.*/gi,
            default: 'VERTICAL_FLOW'
        },
        axis: 'y'
    },
    {
        id: 'HORIZONTAL_FLOW',
        name: 'Columns',
        accepts: {
            containers: /.*/gi,
            components: /.*/gi,
            default: 'VERTICAL_FLOW'
        },
        axis: 'x'
    },
    {
        id: 'INLINE_FLOW',
        name: 'Inline',
        accepts: {
            containers: /.*/gi,
            components: /.*/gi,
            default: 'VERTICAL_FLOW'
        },
        axis: 'x'
    },
    {
        id: 'GROUP',
        name: 'Group',
        accepts: {
            containers: /.*/gi,
            components: [],
            default: 'VERTICAL_FLOW'
        },
        axis: 'y'
    },
    {
        id: 'FLIP',
        name: 'Flip',
        accepts: {
            containers: null,
            components: [],
            default: null
        },
        axis: 'y'
    },
    {
        id: 'CHARTS',
        name: 'Chart',
        accepts: {
            containers: null,
            components: ['chart-bar', 'chart-line', 'chart-pie', 'chart-doughnut', 'chart-polar'],
            default: 'VERTICAL_FLOW'
        },
        axis: 'y'
    }
];
